import React from 'react'
import { Link as GLink } from 'gatsby'
import Sticky from 'react-sticky-el'
import { Container, Box, Flex, css } from 'theme-ui'
import Reveal from '@solid-ui-components/Reveal'
import Drawer from '@solid-ui-components/Drawer'
import ContentImages from '@solid-ui-components/ContentImages'
import ContentButtonsHeader from '@solid-ui-components/ContentButtonsHeader'
import ContentButtons from '@solid-ui-components/ContentButtons'
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent'
import DrawerApps from '../../../../solid-ui-components/src/DrawerApps'
import { useWindowSize } from '../../../../../hooks/hooks'
import ContentButtonsResponsive from '../../../../solid-ui-components/src/ContentButtonsResponsive/ContentButtonsResponsive'

const styles = {
  wrapper: {
    position: `relative`,
    zIndex: 10,
    fill: 'red',
    '.nav-container': {
      bg: `#27A8FF`,
      position: `fixed`,
      transition: `all 250ms ease-in`,
      // overflow: `hidden`,
      position: 'initial',
      py: 3
    },
    '.nav-sticky .nav-container': {
      bg: `#27A8FF`,
      boxShadow: `0 0 25px rgba(140,152,164,.25)`,
      py: [3, null, 2],
    },
    //Make buttons in header smaller
    '.button-group-button': {
      display: 'flex',
      justifyContent: 'center',
      minWidth: 120,
      fontSize: 1,
      px: 3,
      py: 1
    }
  },
  header: {
    justifyContent: `space-between`,
    alignItems: `center`
    // height: [`6rem`, `7rem`], //prevent layout shift
  },
  logoContainer: {
    mt: '7px',
    flexShrink: 0,
    mr: [null, null, 3, 5]
  },
  desktopMenu: {
    display: [`none`, null, `block`],
    minWidth: `auto`,
    flexGrow: 1
  },
  mobileMenu: {
    display: [`block`, null, `none`]
  },
  image: {
    mt: '7px'
  }
}

const HeaderBlock01 = ({ content: { images, collection }, menuJustify }) => {
  const size = useWindowSize();

  return (
    <>
      <Sticky
        enabled='true'
        stickyClassName='nav-sticky'
        css={css(styles.wrapper)}
      >
        <Container variant='full' className='nav-container'>
          <Container px='4'>
            <Flex sx={styles.header}>
              <Box sx={styles.logoContainer}>
                <GLink to='/'>
                  <ContentImages
                    content={{ images }}
                    sx={styles.image}
                    imageEffect='fadeIn'
                    css={css({ 
                      width: '1px'
                    })}
                  />
                </GLink>
              </Box>
              {collection && (
                <>
                  <Box sx={styles.desktopMenu}>
                    <Reveal effect='fadeInDown'>
                      <Flex
                        sx={{
                          alignItems: `center`,
                          justifyContent: menuJustify
                        }}
                      >
                        {collection.map(
                          ({ buttons }, index) =>
                            buttons && (
                              <Box
                                key={`item-${index}`}
                                sx={{
                                  '& + &': {
                                    ml: 4
                                  }
                                }}
                              >
                                <ContentButtonsHeader content={buttons} />
                              </Box>
                            )
                        )}
                      </Flex>
                    </Reveal>
                  </Box>
                  <Box sx={styles.mobileMenu}>
                    <DrawerApps buttonStyle={{ svg: { size: 32 } }}>
                      {collection.map(
                        ({ buttons }, index) =>
                          buttons && (
                            <Box
                              key={`item-${index}`}
                              sx={{
                                fontSize: 3,
                                '.button-group-link.level-1, button-group-link.level-1:visited': {
                                  color: `headerActiveColor`
                                }
                              }}
                            >
                              <ContentButtonsHeader
                                content={buttons[3]}
                                variant='vertical'
                              />
                            </Box>
                          )
                      )}
                    </DrawerApps>
                    <Drawer buttonStyle={{ svg: { size: 32 } }}>
                      {collection.map(
                        ({ buttons }, index) =>
                          buttons && (
                            <Box
                              key={`item-${index}`}
                              sx={{
                                fontSize: 3,
                                '.button-group-link.level-1, button-group-link.level-1:visited': {
                                  color: `headerActiveColor`
                                }
                              }}
                              >
                                <ContentButtonsResponsive
                                  content={buttons.slice(0, 3)}
                                  variant='vertical'
                                />
                            </Box>
                          )
                      )}
                    </Drawer>
                  </Box>
                </>
              )}
            </Flex>
          </Container>
        </Container>
      </Sticky>
    </>
  )
}

HeaderBlock01.defaultProps = {
  menuJustify: `flex-end`
}

export default WithDefaultContent(HeaderBlock01)
